import { useState } from 'react';
import Reveal from '@/components/feature/Reveal';
import { comments } from '@/mocks/home';

export default function CommentSection() {
  const [liked, setLiked] = useState<Record<string, boolean>>({});

  const toggleLike = (key: string) => {
    setLiked((prev) => ({ ...prev, [key]: !prev[key] }));
  };

  return (
    <section id="comments" className="bg-background-100 py-16 md:py-24">
      <div className="mx-auto w-full max-w-5xl px-4 md:px-6">
        <Reveal>
          <div className="flex flex-col gap-3 md:flex-row md:items-end md:justify-between">
            <div>
              <span className="font-label text-xs tracking-[0.28em] text-primary-600">
                COMMUNITY
              </span>
              <h2 className="mt-2 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
                互动广场
              </h2>
            </div>
            <span className="flex w-fit items-center gap-2 rounded-full bg-secondary-100 px-3 py-1.5 font-label text-xs text-secondary-900">
              <span className="flex h-4 w-4 items-center justify-center">
                <i className="ri-chat-smile-2-line text-sm" />
              </span>
              今日 386 条讨论
            </span>
          </div>
        </Reveal>

        <Reveal delay={80} className="mt-8">
          <div className="rounded-lg border border-background-200 bg-background-50 p-4 md:p-5">
            <div className="flex items-start gap-3">
              <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-accent-100 font-heading text-sm font-bold text-accent-900">
                我
              </span>
              <div className="flex-1">
                <div className="rounded-md border border-background-200 bg-background-100 px-3.5 py-3 text-sm text-foreground-500">
                  说说你希望补充的分类或站点方向……
                </div>
                <div className="mt-3 flex items-center justify-between">
                  <span className="font-label text-xs text-foreground-400">登录后可参与讨论</span>
                  <button
                    type="button"
                    className="flex cursor-pointer items-center gap-1.5 whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 font-label text-sm text-background-50 transition-colors hover:bg-primary-600"
                  >
                    <i className="ri-send-plane-line text-base" />
                    发表
                  </button>
                </div>
              </div>
            </div>
          </div>
        </Reveal>

        <div className="mt-6 space-y-4">
          {comments.map((comment, index) => (
            <Reveal key={comment.id} delay={index * 60}>
              <article className="rounded-lg border border-background-200 bg-background-50 p-4 md:p-5">
                <div className="flex items-start gap-3">
                  <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-primary-100 font-heading text-sm font-bold text-primary-800">
                    {comment.initial}
                  </span>
                  <div className="flex-1">
                    <div className="flex flex-wrap items-center gap-x-3 gap-y-1">
                      <span className="font-heading text-sm font-bold text-foreground-950">
                        {comment.name}
                      </span>
                      <span className="font-label text-xs text-foreground-400">{comment.time}</span>
                    </div>
                    <p className="mt-2 text-sm leading-7 text-foreground-700">{comment.content}</p>

                    <div className="mt-3 flex items-center gap-5">
                      <button
                        type="button"
                        onClick={() => toggleLike(comment.id)}
                        className={`flex cursor-pointer items-center gap-1.5 font-label text-xs transition-colors ${
                          liked[comment.id] ? 'text-primary-600' : 'text-foreground-500'
                        }`}
                      >
                        <span className="flex h-4 w-4 items-center justify-center">
                          <i
                            className={
                              liked[comment.id] ? 'ri-heart-3-fill text-sm' : 'ri-heart-3-line text-sm'
                            }
                          />
                        </span>
                        {comment.likes + (liked[comment.id] ? 1 : 0)}
                      </button>
                      <span className="flex items-center gap-1.5 font-label text-xs text-foreground-500">
                        <span className="flex h-4 w-4 items-center justify-center">
                          <i className="ri-chat-3-line text-sm" />
                        </span>
                        {comment.replies.length}
                      </span>
                    </div>

                    {comment.replies.length > 0 && (
                      <div className="mt-4 space-y-3 border-l-2 border-background-200 pl-4">
                        {comment.replies.map((reply) => (
                          <div key={reply.id} className="flex items-start gap-2.5">
                            <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-secondary-100 font-heading text-xs font-bold text-secondary-900">
                              {reply.initial}
                            </span>
                            <div>
                              <div className="flex flex-wrap items-center gap-x-2">
                                <span className="font-heading text-xs font-bold text-foreground-900">
                                  {reply.name}
                                </span>
                                <span className="font-label text-[11px] text-foreground-400">
                                  {reply.time}
                                </span>
                              </div>
                              <p className="mt-1 text-xs leading-6 text-foreground-600">
                                {reply.content}
                              </p>
                            </div>
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                </div>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}